export default __webpack_public_path__ + "static/media/WTON_symbol.4bcaea72.svg";